export const sources = {
	webp: "__VITE_ASSET__VRAku6fjghkApIISiBWPzg__ 400w, __VITE_ASSET__WPGYjwIlzWVNM1bYhOc83w__ 800w"
};
export const img = {
	src: "__VITE_ASSET__WPGYjwIlzWVNM1bYhOc83w__",
	w: 800,
	h: 450
};
export default {
	sources: sources,
	img: img
};
